__turbopack_context__.v({
  "center": "IWKMna_center",
  "container": "IWKMna_container",
  "content": "IWKMna_content",
  "eu-project": "IWKMna_eu-project",
  "gregor": "IWKMna_gregor",
  "hero-reveal": "IWKMna_hero-reveal",
  "link": "IWKMna_link",
  "links": "IWKMna_links",
  "logo": "IWKMna_logo",
  "pixion": "IWKMna_pixion",
  "required": "IWKMna_required",
  "tagline": "IWKMna_tagline",
  "title": "IWKMna_title",
});
